import collectionDatasetsApi from '../datasets/sagas/api';
import collectionDatasetsToasts from '../datasets/sagas/toasts';
import collectionSharingApi from '../sharing/sagas/api';
import collectionSharingLayout from '../sharing/sagas/layout';
import collectionsApi from './api';
import collectionsLayout from './layout';
import collectionsToasts from './toasts';

export default [
  collectionsApi(),
  collectionsLayout(),
  collectionDatasetsApi(),
  collectionDatasetsToasts(),
  collectionSharingApi(),
  collectionSharingLayout(),
  collectionsToasts(),
];
